import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { useFileQuery } from "@query/fileQuery";

const ImageView = ({
  fileUuid,
  className = "",
  sx = {},
  imageSx = {},
  renderCustom
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileQuery = useFileQuery(fileUuid);

  useEffect(() => {
    if (fileQuery.isSuccess && fileQuery.data?.data instanceof Blob) {
      const url = URL.createObjectURL(fileQuery.data.data);
      setPreviewUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [fileQuery.data, fileQuery.isSuccess]);

  return (
    <Box className={className} sx={{ textAlign: "center", ...sx }}>
      {!fileUuid || fileQuery.isLoading ? (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={200}
          sx={{ ...imageSx, mx: "auto" }}
        />
      ) : fileQuery.isError ? (
          <Skeleton
          variant="rectangular"
          width="100%"
          height={200}
          sx={{ ...imageSx, mx: "auto" }}/>
      ) : (
        fileQuery.isSuccess &&
        previewUrl &&
        (renderCustom ? (
          renderCustom({
            fileUuid,
            fileBlob: fileQuery.data?.data,
            fileUrl: previewUrl
          })
        ) : (
          <Box
            component="img"
            src={previewUrl}
            alt="File preview"
            sx={{
              display: "block",
              mx: "auto",
              ...imageSx
            }}
          />
        ))
      )}
    </Box>
  );
};

export default ImageView;